import { StyleSheet } from 'react-native';
import { Buttons } from 'src/theme-v2/buttons';
import { ColorTypography } from 'src/theme-v2/color-typography';
import { brand, neutrals } from 'src/theme/colors';

export const stylesV3 = StyleSheet.create({
  button: {
    flexGrow: 0,
    width: '100%',
    height: 'auto',
    paddingVertical: 13,
    paddingHorizontal: 8.5,
    borderRadius: 8,
  },
  buttonHover: {
    backgroundColor: neutrals.coldGrays.ice,
  },
  buttonSelected: {
    backgroundColor: brand.main.variations['lighterWater-3'],
  },
  buttonFocus: {
    backgroundColor: brand.main.variations['lighterWater-3'],
  },
  buttonDisabled: {
    opacity: 0.6,
  },
  buttonInner: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'start',
  },
  toolDetailsContainer: {
    flex: 1,
    height: '100%',
    width: '100%',
    paddingLeft: 12,
  },
  toolDetails: {
    flexDirection: 'column',
    justifyContent: 'center',
    flex: 1,
    gap: 2,
  },
  toolDetailsText: {
    whiteSpace: 'nowrap',
  },
  toolDetailsTitle: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 18,
    color: ColorTypography.TextColorInteractive,
    textAlign: 'left',
  },
  toolDetailsSubtitle: {
    color: ColorTypography.TextColorTertiary,
    fontWeight: 400,
    fontSize: 12,
    lineHeight: 14,
    textAlign: 'left',
  },
  iconContainer: {
    height: 34,
    width: 34,
    backgroundColor: Buttons.quaternaryOnLight.ButtonQuaternaryOnLightBgDefault,
    borderRadius: 12,
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    color: Buttons.quaternaryOnLight.ButtonQuaternaryOnLightIconDefault,
    width: 16,
    height: 16,
  },
});
